import { FC, useState } from 'react'

import { useUploadBatchFile } from 'commons/hooks/bank/bsa/useUploadBatchFile'
import { CircularProgress } from 'ui/components'

import { Toast } from '../Toast'
import { UploadButton } from '../UploadButton'

import { s } from './styles'

interface Props {
  batchId: number
  isAcknowledgments: boolean
  isCTR: boolean
}

export const UploadBatchPdfButton: FC<Props> = ({ batchId, isAcknowledgments, isCTR }) => {
  const [isUploading, setIsUploading] = useState(false)
  const uploadFileMutation = useUploadBatchFile(isCTR)

  const uploadFile = (file: File) => {
    const formData = new FormData()
    formData.append('batch_id', batchId.toString())
    formData.append('acknowledgments', isAcknowledgments.toString())
    formData.append('pdf', file)

    setIsUploading(true)
    uploadFileMutation
      .mutateAsync(formData, {
        onError: (error) => {
          Toast.errorSmall(error.message)
        },
        onSuccess: () => {
          Toast.successSmall('The PDF file was successfully uploaded')
        }
      })
      .finally(() => setIsUploading(false))
  }

  const onChangeFileInput = (e: any) => {
    const file = e.target.files[0]
    uploadFile(file)
    e.target.value = null
  }

  const getFileInputId = () => (isAcknowledgments ? `batch-${batchId}-acknowledgment-pdf` : `batch-${batchId}-pdf`)

  return isUploading ? (
    <s.Uploading>
      <CircularProgress centered size={32} />
      <span>uploading...</span>
    </s.Uploading>
  ) : (
    <UploadButton id={getFileInputId()} acceptFiles=".pdf" onChange={onChangeFileInput} />
  )
}
